<template>
  <div class="timeline is-centered">
    <header
      class="timeline-header"
      data-aos="zoom-in-up"
      data-aos-delay="600"
      data-aos-duration="800"
    >
      <span class="tag is-medium is-warning">2019</span>
    </header>
    <div
      v-for="(item, index) in reversedPrograms"
      :key="index"
      class="timeline-item is-warning"
      data-aos="zoom-in-up"
      data-aos-delay="600"
      data-aos-duration="800"
    >
      <div class="timeline-marker is-icon is-warning">
        <font-awesome-icon icon="dharmachakra" spin />
      </div>
      <div class="timeline-content is-center">
        <p class="title is-5">{{ item.date }}</p>
        <p class="subtitle is-4">{{ item.topic }}</p>
        <p class>{{ item.topic_desc }}</p>
        <p v-if="item.banthe">{{ item.banthe }}</p>
        <p>{{ item.place }}</p>
      </div>
    </div>
    <div
      class="timeline-header"
      data-aos="zoom-in-up"
      data-aos-delay="600"
      data-aos-duration="800"
    >
      <span class="tag is-medium is-warning">2020</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      programs: [
        {
          date: "ජූලී 16", // TODO update me
          topic: "මාසික ධර්ම දේශනාමය හා භාවනාමය වැඩසටහන",
          topic_desc: "උදෑසන 8 සිට සවස 4 දක්වා",
          place: "බෙලිහුල්ඔය සීලසමාහිත යෝගාශ්‍රමයේ දී",
          done: false
        },
        {
          date: "ජුනී 29 වෙනිදා", // TODO update me
          topic: "සර්වරාත්‍රික බුදුගුණ දේශනාව",
          topic_desc: "සවස 6 සිට පසුදා උදෑසන 6 දක්වා",
          place: "මොනරාගල ප්‍රාදේශීය සභා ක්‍රීඩා පිටියේ දී පැවත්වේ.",
          done: false
        }
        // {
        //   date: "ජනවාරි 23", // TODO update me
        //   topic: "රතනාඝර ප්‍රභා අභිධර්ම වැඩසටහන",
        //   topic_desc: "උදෑසන 8 සිට සවස 4:30 දක්වා",
        //   banthe: "මෙහෙයවීම අතිපූජනීය කන්දෙකුඹුරේ රාධ ස්වාමීන්වහන්ස",
        //   place: "ජාත්‍යන්තර විපස්සනා භාවනා මධ්‍යස්ථානය කොළඹ 07",
        //   done: false
        // }
      ]
    };
  },
  computed: {
    reversedPrograms() {
      return this.programs.slice().reverse();
    }
  },
  methods: {
    // options(index) {
    //   if (index % 2 === 0) {
    //     return {
    //       [`data-aos`]: "fade-right"
    //     };
    //   } else {
    //     return {
    //       [`data-aos`]: "fade-left"
    //     };
    //   }
    // }
  }
};
</script>
